var swiper = new Swiper(".mv-swiper", {
      //640px以下の時
  loop: true,
      //ページネーション
      pagination: {
        el: ".swiper-pagination",
      }, 
      //ナビゲートボタン
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      //スクロールバー
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
      centeredSlides: true,
      slidesPerView: 'auto',//スライド枚数
      spaceBetween: 16,//各スライドの幅
      autoplay: {
        delay: 2500,//1秒後にスライド
        disableOnInteraction: false,//ユーザーアクション後の自動再生を続ける
      },
      breakpoints: {
        //640px以上の時
        769: {
          centeredSlides: true,
          slidesPerView: 'auto',
          spaceBetween: 24,
        },
        
      },
    });